import React from 'react';
import { Alert, Drawer, Space, Typography } from 'antd';
import { ApiOutlined } from '@ant-design/icons';
import EquipoDatosForm from './EquipoDatosForm';

const { Title, Text } = Typography;

// Drawer de creación de un equipo. Envuelve EquipoDatosForm en modo create
// (equipo=null). Si viene preselectedEdificioId, el form lo preselecciona
// y skipea el paso "elegir edificio". El edificio siempre es obligatorio en
// create para forzar la relación equipo↔edificio desde el inicio; registrar
// un equipo sin edificio queda como operación de edición posterior si hace
// falta (caso raro).
function EquipoCreateDrawer({ open, idCliente, preselectedEdificioId, onClose, onCreated }) {
  return (
    <Drawer
      title={
        <Space align="center" size="middle">
          <ApiOutlined />
          <div>
            <Title level={5} style={{ margin: 0 }}>
              Nuevo equipo
            </Title>
            <Text type="secondary" style={{ fontSize: 12 }}>
              Ascensor, escalera mecánica, funicular, rampa o montacargas
            </Text>
          </div>
        </Space>
      }
      placement="right"
      width={720}
      open={open}
      onClose={onClose}
      destroyOnHidden
    >
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="Registro inicial del equipo"
        description="Después de crearlo vas a poder sumarle certificaciones y ver su historial desde el detalle del equipo."
      />
      <EquipoDatosForm
        equipo={null}
        idCliente={idCliente}
        preselectedEdificioId={preselectedEdificioId}
        requireEdificio
        onSaved={(created) => onCreated?.(created)}
      />
    </Drawer>
  );
}

export default EquipoCreateDrawer;
